// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import accordion from "@eisinc/XDL/PreStyle/accordion";
import breadcrumbs from "@eisinc/XDL/PreStyle/breadcrumbs";
import breakpoints from "@eisinc/XDL/PreStyle/breakpoints";
import checkbox from "@eisinc/XDL/PreStyle/checkbox";
import dataTable from "@eisinc/XDL/PreStyle/dataTable";
import datePicker from "@eisinc/XDL/PreStyle/datePicker";
import drawer from "@eisinc/XDL/PreStyle/drawer";
import dynamicDropdown from "@eisinc/XDL/PreStyle/dynamicDropdown";
import globalStyle from "@eisinc/XDL/PreStyle/globalStyle";
import helpers from "@eisinc/XDL/PreStyle/helpers";
import link from "@eisinc/XDL/PreStyle/link";
import lists from "@eisinc/XDL/PreStyle/lists";
import menu from "@eisinc/XDL/PreStyle/menu";
import modal from "@eisinc/XDL/PreStyle/modal";
import pagination from "@eisinc/XDL/PreStyle/pagination";
import panelMenu from "@eisinc/XDL/PreStyle/panelMenu";
import radio from "@eisinc/XDL/PreStyle/radio";
import tab from "@eisinc/XDL/PreStyle/tab";
import tag from "@eisinc/XDL/PreStyle/tag";
import toast from "@eisinc/XDL/PreStyle/toast";
import tooltip from "@eisinc/XDL/PreStyle/tooltip";
import typography from "@eisinc/XDL/PreStyle/typography";
import zIndex from "@eisinc/XDL/PreStyle/zIndex";
import button from "@midpoint/XDL/PreStyle/button";
import formField from "@midpoint/XDL/PreStyle/formField";

// custom
import colors from "@midpoint/XDL/PreStyle/colors";
import { xBaseTheme } from "@midpoint/XDL/types";

export default {
    breakpoints,
    colors,
    // focus,
    // shadows,
    // transition,
    globalStyle,
    typography,
    zIndex,
    accordion,
    breadcrumbs,
    button,
    checkbox,
    // clickable,
    dataTable,
    datePicker,
    drawer,
    dynamicDropdown,
    // fileUpload,
    formField,
    // fieldSet,
    // icon,
    link,
    lists,
    // lazyImage,
    // loadingSpinner,
    menu,
    modal,
    // overflowMenu,
    pagination,
    panelMenu,
    radio,
    // select,
    tab,
    tag,
    // textField,
    // tokenExFrame,
    // textArea,
    toast,
    tooltip,
    // translate,
    helpers,
} as xBaseTheme;
